import { useState } from "react"

import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { useDeleteProductPosition } from "entities/product-positions/api/useDeleteProductPosition"
import { useDeleteProjectChildren } from "entities/project-children/api/useDeleteProjectChildren"

import { DeleteProductPositionsOverlayPayload } from "../DeleteProductPositionsOverlayConnector"

export interface DeleteProductPositionsOverlayModel {
  isLoading?: boolean
  confirm: () => void
  closeOverlay: () => void
}

interface DeleteProductPositionsOverlayModelArgs {
  payload: DeleteProductPositionsOverlayPayload
}

export const useDeleteProductPositionsOverlayModel = ({
  payload: { projectID, productPositions }
}: DeleteProductPositionsOverlayModelArgs) => {
  const { closeOverlay } = useCurrentOverlay()
  const deleteProjectChildren = useDeleteProjectChildren()
  const [deleteProductPosition] = useDeleteProductPosition()
  const [isLoading, setIsLoading] = useState(false)

  const handleDelete = useEvent(() => {
    setIsLoading(true)
    closeOverlay()

    if (productPositions.length === 1) {
      return deleteProductPosition({ id: productPositions[0].id }, projectID)
    }

    return deleteProjectChildren({
      projectID,
      childrenToDelete: productPositions
    })
  })

  return {
    isLoading,
    confirm: handleDelete,
    closeOverlay
  }
}
